import i18n from "@/plugins/vue-i18n";

const OrderSuccessPage = () =>
  import(/* webpackChunkName: "MainLayout" */ "@/views/order-success/index.vue");

const orderSuccess = [
  {
    path: "/order-success/:purchaseOrder",
    name: "OrderSuccess",
    component: OrderSuccessPage,
    meta: {
      title: i18n.t("title.orderSuccessPage"),
    },
  },
];

export default orderSuccess;
